const updates = [
  { time: '12分钟前', title: '《长安如故》第48集更新上线', tag: '大结局', tagColor: 'accent' as const },
  { time: '28分钟前', title: '《深渊之光》第32集全网首播', tag: '更新', tagColor: 'primary' as const },
  { time: '1小时前', title: '《九州风云录》最新预告片发布', tag: '预告', tagColor: 'secondary' as const },
  { time: '2小时前', title: '《星辰大海》全集资源已同步', tag: '全集', tagColor: 'accent' as const },
  { time: '3小时前', title: '新剧《迷雾追踪》定档8月15日', tag: '定档', tagColor: 'primary' as const },
  { time: '5小时前', title: '《岁月如歌》豆瓣评分飙升至9.2', tag: '高分', tagColor: 'accent' as const },
  { time: '8小时前', title: '韩国热剧《黑暗荣耀》全集上线', tag: '引进', tagColor: 'secondary' as const },
  { time: '12小时前', title: '「暑期档片单」专题页面已更新', tag: '专题', tagColor: 'primary' as const },
  { time: '昨天', title: '《职场风云》第三季官宣定档', tag: '官宣', tagColor: 'secondary' as const },
];

const tagStyles = {
  accent: 'bg-accent-50 text-accent-600',
  primary: 'bg-primary-50 text-primary-600',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时追踪最新剧集上线、更新与大事件，让你第一时间掌握热播剧动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5 md:space-y-6">
            {updates.map((item, index) => (
              <div key={index} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 group cursor-pointer">
                <div className="absolute left-2 md:left-3.5 top-1.5 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-primary-400 bg-background-100 group-hover:bg-primary-400 transition-colors flex items-center justify-center">
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-primary-500 group-hover:bg-background-50 transition-colors"></div>
                </div>

                <div className="flex-1 min-w-0 pb-5 md:pb-6 border-b border-background-200 last:border-b-0">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </h3>
                    <span className={`flex-shrink-0 px-2 py-0.5 text-[10px] md:text-xs font-medium rounded-full whitespace-nowrap ${tagStyles[item.tagColor]}`}>
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500 mt-1 block">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}